"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reorder = void 0;
const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    if (startIndex > list.length - 1) {
        // not much that we can do if the dragged item is out of bounds...
        return result;
    }
    if (endIndex > list.length - 1) {
        endIndex = list.length - 1;
    }
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
exports.reorder = reorder;
